// export this package's api
import Align from './Align';
export default Align;


//////////////////
// WEBPACK FOOTER
// ./~/rmc-align/es/index.js
// module id = 132
// module chunks = 0